<div class="wrapper logo-big show-gt-mobile" fxLayout="Column">
  @if (showVersion) {
    <div class="logo">
      <img src="../../../../assets/lfw-logo.png" title="LiveFORMS-Web" alt="LiveFORMS.web logo" />
    </div>
    <div class="version-label">{{ longVersion }}</div>
  }
  @if (!showVersion) {
    <img src="../../../../assets/lfw-logo.png" title="LiveFORMS-Web" alt="LiveFORMS.web logo" height="28px" />
  }
</div>

<div class="wrapper show-lt-mobile">
  <div class="logo">
    <img src="../../../../assets/lfw-logo-small.png" title="LiveFORMS-Web" alt="LiveFORMS.web logo" />
  </div>
  @if (showVersion) {
    <div class="version-label">{{ shortVersion }}</div>
  }
</div>
